import React from 'react'

export default function LegalNotice() {
  return (
    <div>
      
    </div>
  )
}
